<template>
  <section class="_text:light _text:lg _text:center bg-[#09315f] _padding-y:2 _md:padding-y:4">
    <i-container>
      <i-row center-sm>
        <!-- SMARTER Fam Logo -->
        <i-column
          sm="2"
          xs="6"
          class="_display:flex _justify-content:center _padding:0 _sm:margin-right:1 _xs:margin-bottom:2 _sm:margin-bottom:0">
          <i-media class="social-proof-overlay _width:100%">
            <template #image>
              <img
                class="logo-img"
                src="images/logos/e2_logo.png"
                alt="E2 (Economy + Environment)"
                title="E2 (Economy + Environment)" />
            </template>
          </i-media>
        </i-column>

        <!-- Romania Green Building Council Logo -->
        <i-column sm="2" xs="6" class="_display:flex _justify-content:center _padding:0">
          <i-media class="social-proof-overlay _width:100%">
            <template #image>
              <img
                class="logo-img"
                src="images/logos/rogbc_logo_bw.png"
                alt="Romania Green Building Council"
                title="Romania Green Building Council" />
            </template>
          </i-media>
        </i-column>

        <!-- SMARTER4EU Logo -->
        <i-column
          sm="2"
          xs="6"
          class="_display:flex _justify-content:center _padding:0 _xs:margin-bottom:2 _sm:margin-bottom:0">
          <i-media class="social-proof-overlay _width:100%">
            <template #image>
              <img
                class="logo-img"
                src="images/logos/SMARTER4EU_logo.png"
                alt="SMARTER Finance for EU"
                title="SMARTER Finance for EU" />
            </template>
          </i-media>
        </i-column>

        <!-- AIxEnergy Logo -->
        <i-column sm="2" xs="6" class="_display:flex _justify-content:center _padding:0">
          <i-media class="social-proof-overlay _width:100%">
            <template #image>
              <img
                class="logo-img"
                src="images/logos/aixenergy_logo.png"
                alt="AIxEnergy"
                title="AIxEnergy" />
            </template>
          </i-media>
        </i-column>

        <!-- 360Platform Logo -->
        <i-column
          sm="2"
          xs="6"
          class="_display:flex _justify-content:center _padding:0 _margin-bottom:0 _sm:margin-top:0">
          <i-media class="social-proof-overlay _width:100%">
            <template #image>
              <img
                class="logo-img"
                src="images/logos/360platform_logo.png"
                alt="360platform"
                title="360platform" />
            </template>
          </i-media>
        </i-column>
      </i-row>
    </i-container>
  </section>
</template>

<style scoped>
  .social-proof-overlay {
    position: relative;
    display: flex;
    justify-content: center;
  }

  .social-proof-overlay::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #09315f;
    opacity: 0.3;
    pointer-events: none;
  }

  .logo-img {
    width: auto;
    max-width: 100%;
    height: 50px;
    object-fit: contain;
    display: block;
  }

  @media (max-width: 767px) {
    .logo-img {
      height: 50px;
    }
  }
</style>
